import styled, { css } from 'styled-components';

export const QuickAccessWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ApplicationBox = styled.div`
  ${({ theme, $itemHasHandler, $hasMoreApps }) => css`
    position: relative;
    width: 48px;
    height: 48px;
    padding: 12px;
    background: ${theme.v3.colors.neutral[100]};
    border: 1px solid ${theme.v3.colors.neutral[90]};
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: box-shadow 0.3s ease;
    cursor: ${$itemHasHandler ? 'pointer' : 'default'};
    position: relative;
    
    &:hover {
      box-shadow: 0 4px 8px 0 ${theme.v3.colors.neutral[90]}22, 0 3px 6px 0 ${theme.v3.colors.neutral[90]}16;
      background: ${theme.v3.colors.neutral[98]};
    }

    ${$hasMoreApps && css`
      &::before {
        content: '';
        position: absolute;
        top: 100%;
        left: 0;
        width: 18px;
        height: 100px;
        background: transparent;
        z-index: 1000;
      }    

      &::after {
        content: '';
        position: absolute;
        bottom: 0px;
        left: 0;
        width: 100px;
        height: 20px;
        background: transparent;
        z-index: 1000;
      }
    `}
  `}
`;

export const ApplicationIcon = styled.img`
  width: 24px;
  height: 24px;
  display: block;
`;

export const Dropdown = styled.div`
  ${({ theme }) => css`
    position: absolute;
    top: calc(100% - 5px);
    left: 40%;
    min-width: 250px;
    background: ${theme.v3.colors.neutral[100]};
    border-radius: 8px;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.08);
    padding: 8px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    gap: 8px;
  `}
`;

export const DropdownItem = styled.div`
  ${({ theme, $itemHasHandler }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    cursor: ${$itemHasHandler ? 'pointer' : 'default'};
    transition: background 0.2s ease;
    border-radius: 8px;
    
    &:hover {
      background: ${theme.v3.colors.neutral[98]};
    }
  `}
`;

export const DropdownItemName = styled.span`
  ${({ theme }) => css`
    font-size: 16px;
    font-weight: 400;
    color: ${theme.v3.colors.neutral[20]};
    line-height: 1.4;
  `}
`;
